// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import Report from './data'

export default function ReportFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Report">
      <Report {...props}>
        {children}
      </Report>
    </Flow>
  )
}
